import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AuthRequest, DataService} from '../services/data-service';
import { Api } from '../services/api';


const Detail = {
	username:"username",
	name	:"name",
	email	:"email",
	birth	:"birth",
	passowrd:"password",
}

@inject(DataService, Api, EventAggregator)
export class AccountInfoDetail {
	/* MARK: Component life cycle
	   =================================
	*/
	constructor(ds, api, ea){
		this.ds		= ds;
		this.api	= api;
		this.ea		= ea;
		this.Detail = Detail;
		// component model
		this.user_info = { name:null, last_name:null, username:null, email:null}
	}


	activate(params){
		let detail 	= params.detail;
		this.detail	= detail;
	}

	attached(){
		// Event Subscriptions
		this.datePickerSubs = this.ea.subscribe("date-picker:change", msg => this.onDatePickerChange(msg));

		// Init function
		window.setTimeout( () => { this.init(); }, 600 );

		// Get user info from DataService

		// If not user in DS, get from Server

		
	}

	detached(){
		// Remove event subscriptions
		this.datePickerSubs.dispose();
	}

	// Init function
	init(){
		if(!this.ds.user_info){
			// Get remote user info
			this.ds.getUserInfo().then(res => {
				this.user_info = res.data;
			});
		}
		else{
			// Procede
			this.user_info = this.ds.user_info;
		}
	}

	/*	MARK: View methods
		=================================
	 */

	done(user_info, detail){

		this.wasSubmitted = true;
		let fields;
		switch (detail){
			case Detail.name:
				fields = {
					name: user_info.name,
					last_name:user_info.last_name
				}
				this.updateUser(user_info._id, fields)
				break;
			case Detail.username:
				fields = { username: user_info.username };
				this.updateUser(user_info._id, fields);
				break;
			case Detail.email:
				fields = { email: user_info.email };
				this.updateUser(user_info._id, fields);
				break;
			case Detail.birth:
				fields = { birthday: user_info.birthday };
				this.updateUser(user_info._id, fields);
				break;
			default:
				console.log("default");
		}
	}


	updateUser(uid, fields){
		if(this.validate(fields, this.detail)){
			// Update User Info - Auth Service
			let request 	= new AuthRequest("/api/v2/users/"+uid, "PUT");
			let body		= { uid:uid, fields:fields };
			request.headers["Authorization"] = "Bearer " + this.ds.token;
			request.body 	= JSON.stringify(body);
			return this.api.put(request);
		}
	}
	
	// Disable button
	validate(fields, detail){

		let isValid = true;

		switch (detail){
			case Detail.name:
				if( (!fields.name) || (!fields.last_name) ){ isValid = false;}
				break;
			case Detail.username:
				if(!fields.username){ isValid = false;}
				break;
			case Detail.email:
				if(!fields.email){ isValid = false; }
				break;
			case Detail.birth:
				if(!fields.birthday){ isValid = false; }
				break;
			default:
				console.log("default");
		}
		return isValid;
	}
		
	/* MARK: Listeners Events
	   =================================
	*/
	onDatePickerChange(msg){
		let date = msg.body
		this.user_info.birthday = date;
	}
	
	/* MARK: Custom methods
	   =================================
	*/


	backNavi(){ if(history.length != 0){history.back();}}
}
